import React from 'react';
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Card, Typography } from "antd"
import RadioButton from "antd/lib/radio/radioButton";
import { withRouter } from 'react-router-dom'

const { Text, Title } = Typography;



class TablePlan extends React.Component {

    render() {

        return (
            <center>
                <Card
                    title={this.props.title}
                    style={{ border: '1px solid #e3e4e5',
                        borderRadius: '20px',
                        borderTop: 0,
                        background: '#FFF' 
                        }}
                    headStyle={{
                        color: 'white',
                        background: this.props.color,
                        fontWeight: 'bold',
                        borderTopRightRadius: '20px',
                        borderTopLeftRadius: '20px' 
                    }}
                >
                    <Title style={{ color: "#000000" }}>${this.props.price}</Title>
                    <Text> por Mes</Text>
                    <hr style={{ backgroundColor: '#CDCDCD', height: '1px', border: '0' }} />
                    <Text style={{ fontSize: 13 }}>{this.props.subtitle}</Text>
                    <br /><br />
                    <RadioButton value={this.props.button_value}
                        style={{color: '#FFFFFF' ,
                                background: '#353FDF',
                                border: '1px solid #353FDF',
                                borderRadius: '5px' }}
                    >Quiero este!</RadioButton>
                </Card>
            </center>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TablePlan));
